/**
 * Date-extensions locale Polish [pl]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('pl', {
    monthNames: ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
    monthShortNames: ['Sty','Lut','Mar','Kwi','Maj','Cze','Lip','Sie','Wrz','Paź','Lis','Gru'],
    dayNames: ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
    dayShortNames: ['Ndz','Pon','Wt','Śr','Czw','Pt','Sob']
});
